export const SELECTABLE_HOVER_COLOR = '#FFD600';
export const SELECTABLE_SELECTED_COLOR = '#66D98A';

/** @typedef {'normal' | 'hovered' | 'selected'} SelectableVisualState */

/**
 * @param {{ isSelected?: boolean; isHovered?: boolean }} params
 * @returns {SelectableVisualState}
 */
export function resolveSelectableVisualState({ isSelected = false, isHovered = false }) {
  if (isSelected) return 'selected';
  if (isHovered) return 'hovered';
  return 'normal';
}

/**
 * @param {{ visualState: SelectableVisualState; normalColor: string }} params
 * @returns {string}
 */
export function resolveSelectableDisplayColor({ visualState, normalColor }) {
  if (visualState === 'selected') return SELECTABLE_SELECTED_COLOR;
  if (visualState === 'hovered') return SELECTABLE_HOVER_COLOR;
  return normalColor;
}

/**
 * @param {{ isSelected?: boolean; isHovered?: boolean; normalColor: string }} params
 * @returns {string}
 */
export function resolveSelectableColor({ isSelected = false, isHovered = false, normalColor }) {
  return resolveSelectableDisplayColor({
    visualState: resolveSelectableVisualState({ isSelected, isHovered }),
    normalColor,
  });
}
